import { GLASS_CHIP_CLASS, type GlassTheme } from "@/components/home/glass";
import { useVisibleT } from "@/lib/cms/cms-new-i18n";
import { cn } from "@/lib/utils";

/** Haut de l'accueil : « Tableau de bord / Bonjour … » et nom de l'instance. */
export const HomeHero = ({
  theme,
  userName,
  instanceName,
}: {
  theme: GlassTheme;
  userName: string;
  instanceName: string | undefined;
}) => {
  const vt = useVisibleT();
  return (
    <div className="flex flex-wrap items-start justify-between gap-2.5 px-6 pb-5 pt-3">
      <div
        className={cn(GLASS_CHIP_CLASS, "flex flex-col rounded-xl px-5 py-2.5")}
        style={theme.surface}
      >
        <h1 className="text-xl font-extrabold">
          {vt("bo.home.title", "Tableau de bord")}
        </h1>
        {userName && (
          <p className="text-base font-semibold italic">
            {vt("bo.home.greeting", "Bonjour,")} {userName}
          </p>
        )}
      </div>
      {instanceName && (
        <div
          className={cn(
            GLASS_CHIP_CLASS,
            "rounded-full px-4 py-2 text-sm font-semibold",
          )}
          style={theme.surface}
        >
          {instanceName}
        </div>
      )}
    </div>
  );
};
